<template>
  <nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-dark shadow">
    <!-- Container wrapper -->
    <div class="container">
      <a class="navbar-brand" href="#" @click="toHome">ToS</a>
      <!-- Toggle button -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Collapsible wrapper -->
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <!-- Left links -->
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item">
            <a class="nav-link" href="#" @click="toHome">Kalkulace</a>
          </li>
<!--          <li class="nav-item">-->
<!--            <a class="nav-link" href="#" @click="toCustomers">Zákazníci</a>-->
<!--          </li>-->
          <li class="nav-item">
            <a class="nav-link" href="#" @click="toOrders">Objednávky</a>
          </li>
          <li v-if="isAdmin" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Admin</a>
            <ul class="dropdown-menu">
<!--              <li><a class="dropdown-item" href="#" @click="toAdminUnits">Jednotky</a></li>-->
<!--              <li><a class="dropdown-item" href="#" @click="toAdminMaterials">Materiály</a></li>-->
<!--              <li><a class="dropdown-item" href="#" @click="toAdminThickness">Tloušťky materiálů</a></li>-->
              <li><a class="dropdown-item" href="#" @click="toAdminPriceList">Ceníky</a></li>
<!--              <li><a class="dropdown-item" href="#" @click="toAdminActions">Obrábění</a></li>-->
<!--              <li><a class="dropdown-item" href="#" @click="toAdminUsers">Uživatelé</a></li>-->
<!--              <li>-->
<!--                <hr class="dropdown-divider">-->
<!--              </li>-->
<!--              <li><a class="dropdown-item" href="#" @click="toAdminExports">Exporty</a></li>-->
            </ul>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#" @click="toAbout">About</a>
          </li>
        </ul>
        <ul v-if="userShow" class="navbar-nav d-flex flex-row me-1">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">{{ userFullName }}
            <i class="bi bi-person" style="font-size: 1.5em;"></i>
            </a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item" href="#" @click="logout">Odhlásit se</a></li>
              <li><a class="dropdown-item" href="#" @click="toChangePassword">Změna hesla</a></li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script setup>
import {ref, computed, watch} from 'vue'
import {useStore} from 'vuex'
import router from "@/router"

const store = useStore()
const userShow = ref(false)
const userFullName = ref("")
const isAdmin = ref(false)

const user = computed(() => store.getters['getUser'])
const isAuth = computed(() => store.getters['getIsAuthenticated'])
const fullName = computed(() => {
  const user = store.getters['getUser']
  if (user) {
    return `${user.last_name} ${user.first_name}`
  } else {
    return ""
  }
})

const toHome = () => router.push({name: 'home'})
const toAbout = () => router.push({name: 'about'})
// const toAdminUnits = () => router.push({name: 'adminUnitsView'})
// const toAdminMaterials = () => router.push({name: 'adminMaterialsView'})
// const toAdminThickness = () => router.push({name: 'adminThicknessView'})
const toAdminPriceList = () => router.push({name: 'adminPriceListView'})
// const toAdminActions = () => router.push({name: 'adminActionsView'})
// const toAdminUsers = () => router.push({name: 'adminUsersView'})
// const toAdminExports = () => router.push({name: 'adminExportsView'})
const logout = () => store.dispatch("logoutUser").then(() => router.replace("/login"))
const toChangePassword = () => router.push({name: 'passwordChangeView'})
// const toCustomers = () => router.push({name: 'customerView'})
const toOrders = () => router.push({name: 'ordersView'})

watch(isAuth, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    userShow.value = newVal
  }
})

watch(fullName, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    userFullName.value = newVal
  }
})

watch(user, (newVal, oldVal) => {
  if (newVal === oldVal) {
    return null
  } else if (newVal && newVal.is_superuser) {
    isAdmin.value = true
  } else {
    isAdmin.value = false
  }
}, {deep: true, immediate: true})
</script>


<style scoped>
</style>

